import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { FileText, Scale, AlertTriangle, CheckCircle } from 'lucide-react'

import Section from '../components/ui/Section'
import GlassCard from '../components/ui/GlassCard'

const Terms = () => {
  const { t } = useTranslation()

  const sections = [
    {
      icon: FileText,
      title: "Acceptation des conditions",
      content: "En utilisant ce site web, vous acceptez d'être lié par ces conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre site."
    },
    {
      icon: CheckCircle,
      title: "Utilisation autorisée",
      content: "Vous pouvez utiliser notre site pour obtenir des informations sur nos services d'accompagnement en déficience intellectuelle, prendre rendez-vous ou nous contacter. Toute utilisation à des fins illégales ou inappropriées est interdite."
    },
    {
      icon: AlertTriangle,
      title: "Limitation de responsabilité",
      content: "Résidences Masséna Inc. s'efforce de fournir des informations précises et à jour. Cependant, nous ne pouvons garantir l'exactitude complète de toutes les informations présentées sur ce site."
    },
    {
      icon: Scale,
      title: "Propriété intellectuelle",
      content: "Tout le contenu de ce site (textes, images, logos) est protégé par les droits d'auteur et appartient à Résidences Masséna Inc. Toute reproduction sans autorisation est interdite."
    }
  ]

  return (
    <div className="min-h-screen pt-32 pb-20">
      <Section
        title="Conditions d'Utilisation"
        subtitle="Termes et conditions régissant l'utilisation de notre site web"
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto space-y-8"
        >
          {/* Introduction */}
          <GlassCard className="p-8">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full mb-4">
                <Scale className="w-8 h-8 text-primary-600" />
              </div>
              <h2 className="text-2xl font-bold text-black mb-4">
                Conditions d'Utilisation du Site Web
              </h2>
              <p className="text-gray-600 leading-relaxed">
                Ces conditions d'utilisation régissent l'utilisation du site web de Résidences Masséna Inc. 
                En accédant à ce site, vous acceptez ces conditions dans leur intégralité.
              </p>
            </div>
          </GlassCard>

          {/* Sections principales */}
          {sections.map((section, index) => {
            const Icon = section.icon
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <GlassCard className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                        <Icon className="w-6 h-6 text-primary-600" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-black mb-3">
                        {section.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {section.content}
                      </p>
                    </div>
                  </div>
                </GlassCard>
              </motion.div>
            )
          })}

          {/* Contact */}
          <GlassCard className="p-8 bg-gradient-to-br from-primary-50 to-blue-50">
            <div className="text-center">
              <h3 className="text-xl font-bold text-black mb-4">
                Questions sur ces conditions ?
              </h3>
              <p className="text-gray-600 mb-6">
                Si vous avez des questions concernant ces conditions d'utilisation, 
                n'hésitez pas à nous contacter pour plus d'informations.
              </p>
              <div className="space-y-2 text-sm text-gray-700">
                <p><strong>Email :</strong> admin@residencemassena.com</p>
                <p><strong>Téléphone :</strong> (450) 628-2696</p>
                <p><strong>Adresse :</strong> 444 Avenue Yvon-Berger, Laval, QC H7L 2C2</p>
              </div>
            </div>
          </GlassCard>

          {/* Dernière mise à jour */}
          <div className="text-center text-sm text-gray-500">
            <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-CA')}</p>
          </div>
        </motion.div>
      </Section>
    </div>
  )
}

export default Terms


